import { withResolvers, delay } from "@otto-ec/assets-core-utils/promise";
import type { ExactagData } from "../core/core.types";
import { exactagData } from "../core/data";
import { exactagScope } from "../core/utils";
import type { VerticalDataCallback } from "./collect.types";

const log = exactagScope.scope("collect.vertical");

/**
 *
 */
export const verticalDataRetrievalCallbacks: Record<
  string,
  VerticalDataCallback | { promise: Promise<VerticalDataCallback>, resolve: (result: VerticalDataCallback) => void } | undefined
> = {};

/**
 *
 *
 *
 *
 *
 */
export function registerVerticalDataCallback(
  triggerID: string,
  cb: VerticalDataCallback
): void {
  const existingCallbackOrAwaiter = verticalDataRetrievalCallbacks[triggerID];

  if(!existingCallbackOrAwaiter) {
    log.info("Registering vertical data callback for trigger ID", triggerID);
    verticalDataRetrievalCallbacks[triggerID] = cb;
    return;
  }

  if (typeof existingCallbackOrAwaiter === "function") {
    log.warn(
      "Overwriting existing vertical data callback for trigger ID",
      triggerID
    );
    verticalDataRetrievalCallbacks[triggerID] = cb;
    return;
  }
  

  log.info("Resolving vertical data callback for trigger ID", triggerID);
  existingCallbackOrAwaiter.resolve(cb);
}

export async function addVerticalDataFromElement(this: ExactagData, element: HTMLElement) {
  const data = this;

  /*                                                           */
  const { trigger: triggerID } = element.dataset;
  if (!triggerID) {
    log.warn("No trigger ID found in element", element);
    return;
  }

  /*                                  */
  let fn = verticalDataRetrievalCallbacks[triggerID];
  if (!fn || typeof fn !== "function") {
    log.info("No function registered for trigger ID", triggerID, "init awaiter");

    const [promise, resolve] = withResolvers<VerticalDataCallback>()
    verticalDataRetrievalCallbacks[triggerID] = { promise, resolve: resolve as never };

    log.info("Awaiting function registration for trigger ID", triggerID);
    fn = await Promise.race([promise, delay<undefined>(500)]);
  }

  if (!fn || typeof fn !== "function") {
    log.warn("No function registered for trigger ID", triggerID, "after awaiting");
    return;
  }

  log.info("Executing vertical data callback for trigger ID", triggerID);
  let result = await fn(data, element);

  if (!result || typeof result !== "object") {
    log.info("No data returned from function for trigger ID", triggerID);
    return;
  }

  if (result === data) {
    log.warn(
      "Callback function for trigger ID",
      triggerID,
      "returned the same object as input!"
    );
    return;
  }

  log.info("Adding data from function for trigger ID", triggerID, result);
  Object.assign(data, result);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export async function addVerticalsData(data = exactagData): Promise<ExactagData> {
  /*                                                 */
  const activeExactagElements = document.querySelectorAll<HTMLElement>(".exactag")
  /*       */
  for (const element of activeExactagElements) {
    await addVerticalDataFromElement.call(data, element)
  }
  return data;
}
